const locale = {
  locale: 'mn',
  Pagination: {
    items_per_page: '/ хуудас',
    jump_to: 'Очих',
    jump_to_confirm: 'confirm',
    page: '',
    prev_page: 'Ѳмнѳх хуудас',
    next_page: 'Дараагийн хуудас',
    prev_5: 'Ѳмнѳх 5 хуудас',
    next_5: 'Дараагийн 5 хуудас',
    prev_3: 'Ѳмнѳх 3 хуудас',
    next_3: 'Дараагийн 3 хуудас',
  },
  DatePicker: {
    lang: {
      placeholder: 'Ѳдѳр сонгох',
      rangePlaceholder: ['Эхлэх ѳдѳр', 'Дуусах ѳдѳр'],
      today: 'Ѳнѳѳдѳр',
      now: 'Одоо',
      backToToday: 'Ѳнѳѳдѳрлүү буцах',
      ok: 'Тийм',
      clear: 'Цэвэрлэх',
      month: 'Сар',
      year: 'Жил',
      timeSelect: 'Цаг сонгох',
      dateSelect: 'Ѳдѳр сонгох',
      monthSelect: 'Сар сонгох',
      yearSelect: 'Жил сонгох',
      decadeSelect: '10 жил сонгох',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-M-D',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-M-D HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: 'Ѳмнѳх сар',
      nextMonth: 'Дараа сар',
      previousYear: 'Дараа жил (Control + зүүн)',
      nextYear: 'Дараа жил (Control + баруун)',
      previousDecade: 'Ѳнгѳрсѳн 10 жил',
      nextDecade: 'Дараагийн 10 жил',
      previousCentury: 'Ѳнгѳрсѳн зуун',
      nextCentury: 'Дараагийн зуун',
    },
    timePickerLocale: {
      placeholder: 'Цаг сонгох',
    },
  },
  TimePicker: {
    placeholder: 'Цаг сонгох',
  },
  Calendar: {
    lang: {
      placeholder: 'Ѳдѳр сонгох',
      rangePlaceholder: ['Эхлэх ѳдѳр', 'Дуусах ѳдѳр'],
      today: 'Ѳнѳѳдѳр',
      now: 'Одоо',
      backToToday: 'Ѳнѳѳдѳрлүү буцах',
      ok: 'Тийм',
      clear: 'Цэвэрлэх',
      month: 'Сар',
      year: 'Жил',
      timeSelect: 'Цаг сонгох',
      dateSelect: 'Ѳдѳр сонгох',
      monthSelect: 'Сар сонгох',
      yearSelect: 'Жил сонгох',
      decadeSelect: '10 жил сонгох',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-M-D',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-M-D HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: 'Ѳмнѳх сар',
      nextMonth: 'Дараа сар',
      previousYear: 'Дараа жил (Control + зүүн)',
      nextYear: 'Дараа жил (Control + баруун)',
      previousDecade: 'Ѳнгѳрсѳн 10 жил',
      nextDecade: 'Дараагийн 10 жил',
      previousCentury: 'Ѳнгѳрсѳн зуун',
      nextCentury: 'Дараагийн зуун',
    },
    timePickerLocale: {
      placeholder: 'Цаг сонгох',
    },
  },
  Table: {
    filterTitle: 'Шүүх цэс',
    filterConfirm: 'Тийм',
    filterReset: 'Шинэчлэх',
    emptyText: 'Олдсонгүй',
    selectAll: 'Бүгдийг сонгох',
    selectInvert: 'Сонголтыг болиулах',
  },
  Modal: {
    okText: 'Тийм',
    cancelText: 'Болих',
    justOkText: 'Тийм',
  },
  Popconfirm: {
    okText: 'Тийм',
    cancelText: 'Үгүй',
  },
  Transfer: {
    notFoundContent: 'Олдсонгүй',
    searchPlaceholder: 'Хайлт',
    itemUnit: 'item',
    itemsUnit: 'items',
  },
  Select: {
    notFoundContent: 'Олдсонгүй',
  },
  Upload: {
    uploading: 'Хуулж байна',
    removeFile: 'Устгах',
    uploadError: 'Хуулахад алдаа гарлаа',
    previewFile: 'Харах',
  },
};

export default locale;



// WEBPACK FOOTER //
// ./src/utils/locale.js